import {
  Grid,
  IconButton,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import LoaderComponent from "../Loader";
import ModalComponent from "../Modal";
import { Info } from "@mui/icons-material";
import { useTranslations } from "next-intl";
import Image from "next/image";
import { IMAGES, WEB_COLORS } from "@/lib/constants";
import ButtonComponent from "../Button";

export const BankVarificationModal = ({
  employmentType,
  open,
  handleModal,
  error,
  btnOnClick,
  showBtn = true,
}) => {
  const t = useTranslations(
    employmentType === "Salaried"
      ? "offers.bankOfferErrorSalaried"
      : "offers.bankOfferErroSelfEmployed"
  );
  const theme = useTheme();
  const isBelowMd = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <ModalComponent
      maxWidth={"md"}
      open={open}
      extraFunction={() => {}}
      closeButtonRequired
      handleModal={handleModal}
    >
      <Grid
        container
        // spacing={3}
        padding={0}
        // flexDirection={{ md: "row", xs: "column" }}
        alignItems="center"
        justifyContent={"space-between"}
        gap={1}
      >
        <Grid
          item
          md={6}
          xs={12}
          sx={{
            backgroundColor: { md: "#E9FFE6", xs: "none" },
            height: { md: "436px" },
            width: { md: "463px" },
          }}
          display={"flex"}
          justifyContent={"center"}
          alignItems={"center"}
        >
          <Image
            src={IMAGES.building}
            height={isBelowMd ? "120" : "191px"}
            width={isBelowMd ? "135" : "216px"}
            alt="bank verification"
          />
        </Grid>
        <Grid item md={5} xs={12}>
          <Typography
            textAlign={{ xs: "center", md: "left" }}
            fontWeight={{ md: 700, xs: 500 }}
            fontSize={{ md: "24px", xs: "16px" }}
            color={WEB_COLORS.darkTeal}
            mb={1}
          >
            {t("verificationFailureTitle")}
          </Typography>
          <Typography
            textAlign={{ xs: "center", md: "left" }}
            fontWeight={400}
            fontSize={{ md: "14px", xs: "12px" }}
            color={WEB_COLORS.textFadeColor}
            mb={2}
          ></Typography>

          <Stack my={1} gap={2}>
            <Typography
              fontSize={{ xs: "14px", sm: "16px" }}
              marginBottom={-1}
              fontWeight={400}
            >
              {t("pleaseEnsure")}
            </Typography>
            <ul
              style={{
                paddingLeft: "1.5rem",
              }}
            >
              <li>
                {" "}
                <Typography fontSize={{ xs: "12px", sm: "14px" }}>
                  {" "}
                  {t.rich("verificationGuidelines1", {
                    bold: (chunks) => <strong>{chunks}</strong>,
                  })}
                </Typography>
              </li>
              <li>
                {" "}
                <Typography fontSize={{ xs: "12px", sm: "14px" }}>
                  {" "}
                  {t.rich("verificationGuidelines2", {
                    bold: (chunks) => <strong>{chunks}</strong>,
                  })}
                </Typography>
              </li>
              <li>
                {" "}
                <Typography fontSize={{ xs: "12px", sm: "14px" }}>
                  {" "}
                  {t.rich("verificationGuidelines3", {
                    bold: (chunks) => <strong>{chunks}</strong>,
                  })}
                </Typography>
              </li>
            </ul>
            {error && (
              <Stack direction="row" alignItems="center" spacing={1}>
                <Info fontSize="small" style={{ color: "#f44336" }} />
                <Typography fontSize={{ xs: "12px", sm: "14px" }} color={"red"}>
                  {error}
                </Typography>
              </Stack>
            )}
          </Stack>

          {showBtn && (
            <Stack mt={2}>
              <ButtonComponent
                sx={{
                  width: {
                    xs: "100%",
                    sm: "50%",
                    md: "275px",
                    textTransform: "capitalize",
                  },
                }}
                onClick={btnOnClick}
                type="button"
              >
                {t("retryBankValidation")}
              </ButtonComponent>
            </Stack>
          )}
        </Grid>
      </Grid>
    </ModalComponent>
  );
};
